import { OnInit, OnDestroy} from '@angular/core';
import { Component } from '@angular/core';
import { AfterViewInit } from '@angular/core';
import { IContextService, DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-childWiindow',
    templateUrl: './dojo-childWindow.component.html'
})
export class DojoChildWindowComponent implements OnInit, AfterViewInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;

    constructor(
        private contextService: IContextService) {
      }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.renderchildWindow();
        });
    }

    ngAfterViewInit(): void {

    }

    ngOnDestroy(): void {

    }

    renderchildWindow() {
        if (dojoApp) {
            dojoApp.renderChildWindow();
        }
    }
}
